import React, { useState, useEffect } from "react";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";

import StripeCheckout from "./StripeCheckout";
import { HOST } from "../../../urls";

const stripeKeyGWD = process.env.REACT_APP_STRIPE_KEY_GWD;
const stripeKeyOther = process.env.REACT_APP_STRIPE_KEY_NOD;
console.log(stripeKeyGWD, "STRIPE KEY GWD")
const stripePromise =
  HOST == "GWD"
    ? loadStripe(
      stripeKeyGWD
      )
    : loadStripe(
      stripeKeyOther
      );

export function Provider(props) {
  useEffect(() => {
    // Create PaymentIntent as soon as the page loads
    // fetch("/create-payment-intent", {
    //   method: "POST",
    //   headers: { "Content-Type": "application/json" },
    //   body: JSON.stringify({ items: [{ id: "xl-tshirt" }] }),
    // })
    //   .then((res) => res.json())
    //   .then((data) => setClientSecret(data.clientSecret));
  }, []);

  return (
    console.log(props, "PROPS>"),
    (
      <div style={{ width: "100%" }}>
        <Elements stripe={stripePromise}>
          <StripeCheckout
            emailId={props.emailId}
            mobileNumber={props.mobileNumber}
            name={props.name}
            getNamesFromItems={props.getNamesFromItems}
            handleProgressBar={() => props.handleProgressBar()}
          />
        </Elements>
      </div>
    )
  );
}
